module.exports = __webpack_public_path__ + "static/media/auovs.d4b21d43.png";